import script from "./dealDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./dealDialog.vue?vue&type=script&setup=true&lang=js"

import "./dealDialog.vue?vue&type=style&index=0&id=59dd1b6b&scoped=true&lang=css"

import exportComponent from "/jenkins/workspace/zh-workflow-frontend_prev/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59dd1b6b"]])

export default __exports__